import { TreeNode } from 'primeng/api';
import { Injectable } from '@angular/core';
import { JournodexGeographyModel } from '../../Journodex/models/journodex-geography.model';
import { RegionSelectDialogService } from '../../Dialogs/services/region-select-dialog.service';
import { IncludeOrExclude } from '../../Dialogs/services/data-select-dialog.service.interface';
import { TargetingGeographyService } from './targeting-geography-service';

@Injectable()
export class TargetingSearchRegionSelectDialogService extends RegionSelectDialogService {

    selectionsLoaded = false;
    continentResults: JournodexGeographyModel[];
    selectedRegions: JournodexGeographyModel[] = [];

    constructor(
        protected geographyService: TargetingGeographyService,
    ) {
        super(geographyService);
    }

    applySelectedListItems(selectedItems: TreeNode[], filterChildren: boolean = true): void {
        this.selectedRegions = [];
        let newSelectedItems = selectedItems;
        // for certain scenarios (ex: Target Audience Region)
        // we do not want to filter out the child nodes on submit
        if (filterChildren) {
            newSelectedItems = this.filterOutNodeChildren(selectedItems);
        }
        for (const selectedItem of newSelectedItems) {
            this.selectedRegions.push(<JournodexGeographyModel>selectedItem.data);
        }
    }

    public setAppropriateListItems(): void {
        if (this.state === undefined) {
            return;
        }

        this.selectionsLoaded = false;
        this.setSelectedRegions(this.selectedRegions);
        this.selectionsLoaded = true;
        this.buildTree();
    }

    // override so it doesn't attempt to build the tree until we loaded the selections
    getContinentRegions(): void {
        this.continentResults = [];
        this.geographyService.getContinents().subscribe(
            results => {
                this.continentResults = results;
                this.buildTree();
            }
        );
    }

    buildTree() {
        if (this.continentResults && this.continentResults.length > 0 && this.selectionsLoaded) {
            this.listItems = this.convertApiResponseToTreeNode(this.continentResults).slice();
            this.listItems.sort( (a, b) => {
                return a.label.localeCompare(b.label);
            });

            this.listItems.forEach(
                (item, index) => {
                    const selectedItem = this.flattenedSelectedRegions.find(
                        selectedNode => {
                            return selectedNode.data.collectionId === item.data.collectionId;
                        }
                    );
                    if (selectedItem) {
                        this.listItems[index] = selectedItem;
                    }
                }
            );
            this.listItemProvider.next(this.listItems);
        }
    }

    prepareData(state: IncludeOrExclude, regionIds: number[]) {
        this.geographyService.getByGeographyIds(regionIds).subscribe(regions => {
            this.selectedRegions = regions;
            this.setState(state);
        });
    }

    prepareModelData(state: IncludeOrExclude, regions: JournodexGeographyModel[]) {
        this.selectedRegions = regions;
        this.setState(state);
    }
}
